import { z } from 'zod';

import { GetOrganizationResponseSchema } from './get-organization.schemas.js';
import { OrganizationCadastralWriteFieldsSchema } from './organization-cadastral.schemas.js';

export const UpdateOrganizationBodySchema = z.object({
  name: z.string().min(1),
  slug: z
    .string()
    .min(2)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  ...OrganizationCadastralWriteFieldsSchema.shape,
});

export type UpdateOrganizationBody = z.infer<typeof UpdateOrganizationBodySchema>;

export const UpdateOrganizationResponseSchema = GetOrganizationResponseSchema;

export type UpdateOrganizationResponse = z.infer<typeof UpdateOrganizationResponseSchema>;
